export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const PHONE = '+7 708 027 37 67';
export const EMAIL = 'e.lugina@andersenlab.com';

export const MEETUP_DATE = '2025-11-12';
export const MEETUP_TIME = '14:30';
export const TIME_ZONE = 'UTC+5';
